<script>
import resources from './resources'

export default {
  name: 'crud-form',

  mixins: [resources]
}
</script>

<template lang="pug">
  div
</template>



// WEBPACK FOOTER //
// src/crud/form/form.vue